export default "<div class=\"mc-body\">\r\n    {{{ recipientes }}}\r\n</div>\r\n"